import type { AxiosError } from 'axios';

/**
 * Extract human-readable error message from an Axios error response.
 * Falls back to the provided default message if no detail is available.
 */
export function extractErrorMessage(error: unknown, fallback: string): string {
  const axiosError = error as AxiosError<{ detail?: string }>;
  return axiosError?.response?.data?.detail ?? fallback;
}
